module.exports = {
  messageCenterComponentEvents: {
    MessageInbox: {
      code: 'INBOX',
      events: {
        PageLoad: {
          description: 'Triggers when user loads the message inbox page',
          eventHub: {
            code: 'LOAD',
            action: 'MsgInbox_Page loaded'
          }
        },
        ClickMessage: {
          description: 'Triggers when user clicks on a message thread',
          eventHub: {
            code: 'CLICKMSG',
            action: 'MsgInbox_Clicked Message',
            dataKeys: ['type', 'subject']
          }
        },
        ClickNewMessage: {
          description: 'Triggers when user clicks on New Message button',
          eventHub: {
            code: 'CLICKNEWMSG',
            action: 'MsgInbox_Clicked New message'
          }
        }
      }
    },
    NewMessage: {
      code: 'NEW',
      events: {
        PageLoad: {
          description: 'Triggers when user loads the new message page',
          eventHub: {
            code: 'LOAD',
            action: 'NewMessage_Page loaded'
          }
        },
        SendMessage: {
          description: 'Triggers when user clicks on sends a new message',
          eventHub: {
            code: 'SEND',
            action: 'NewMessage_Clicked Send',
            dataKeys: ['isDocumentAttached']
          }
        },
        AttachFile: {
          description: 'Triggers when user clicks add file',
          eventHub: {
            code: 'ATTACH',
            action: 'NewMessage_Clicked Add File'
          }
        }
      }
    },
    NoWithdrawCase: {
      code: 'NOWITHDRAW',
      events: {
        PageLoad: {
          description: 'Triggers when user loads no withdraw page',
          eventHub: {
            code: 'LOAD',
            action: 'NoWithdrawCase_Page loaded'
          }
        },
        ClickOK: {
          description: 'Triggers when user clicks on OK',
          eventHub: {
            code: 'OK',
            action: 'NoWithdrawCase_Clicked OK'
          }
        },
        ClickWithdrawal: {
          description: 'Triggers when user clicks Withdrawal',
          eventHub: {
            code: 'CLICKWITHDRAWAL',
            action: 'NoWithdrawCase_Clicked Withdrawal'
          }
        }
      }
    },

    NoTransferCase: {
      code: 'NOTRANSFER',
      events: {
        PageLoad: {
          description: 'Triggers when user loads no transfer page',
          eventHub: {
            code: 'LOAD',
            action: 'NoTransferCase_Page loaded'
          }
        },
        ClickOK: {
          description: 'Triggers when user clicks OK',
          eventHub: {
            code: 'OK',
            action: 'NoTransferCase_Clicked OK'
          }
        },
        ClickTransfer: {
          description: 'Triggers when user clicks Transfer',
          eventHub: {
            code: 'CLICKTRANSFER',
            action: 'NoTransferCase_Clicked Transfer'
          }
        }
      }
    },
    MessageSuccess: {
      code: 'SUCCESS',
      events: {
        PageLoad: {
          description: 'Triggers when send success page loads',
          eventHub: {
            code: 'LOAD',
            action: 'SendSuccess_Page loaded'
          }
        },
        ClickDone: {
          description:
            'Triggers when user clicks Done button in the success dialog',
          eventHub: {
            code: 'CLICKDONE',
            action: 'SendSuccess_Clicked Done'
          }
        }
      }
    },
    MessageFail: {
      code: 'FAIL',
      events: {
        PageLoad: {
          description: 'Triggers when send fail page loads',
          eventHub: {
            code: 'LOAD',
            action: 'SendFail_Page loaded'
          }
        },
        ClickDone: {
          description:
            'Triggers when user clicks Done button in the fail dialog',
          eventHub: {
            code: 'CLICKDONE',
            action: 'SendFail_Clicked Done'
          }
        }
      }
    },
    MessageView: {
      code: 'VIEW',
      events: {
        PageLoad: {
          description: 'Triggers when user loads a message thread view page',
          eventHub: {
            code: 'LOAD',
            action: 'ViewMessage_Page loaded'
          }
        },
        SendMessage: {
          description: 'Triggers when user sends a message in a thread',
          eventHub: {
            code: 'SEND',
            action: 'ViewMessage_Clicked Send',
            dataKeys: ['isDocumentAttached']
          }
        },
        AttachFile: {
          description: 'Triggers when user attaches a file to a message',
          eventHub: {
            code: 'ATTACH',
            action: 'ViewMessage_Clicked Add File'
          }
        }
      }
    },
    ClosedMessage: {
      code: 'CLOSEDMSG',
      events: {
        StartNewChat: {
          description: 'Triggers when user clicks start new chat',
          eventHub: {
            code: 'CLICKNEWCHAT',
            action: 'ClosedMessage_Clicked Start new chat'
          }
        }
      }
    }
  }
};
